import React from 'react';

import { Button } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { CustomCopyElement } from '../../CustomCopyElement.jsx';
import CustomTooltip from '../../CustomTooltip.jsx';
import { validateEditorData } from '../../editor/defaultOptions.js';
import FieldGroup from '../../FieldGroup.jsx';
import { FormError } from '../../FormError.jsx';
import QuestionBlueIcon from '../../icons/QuestionBlueIcon.jsx';

import Editor from '../../editor/editor.jsx';

const CustomizeEmailTemplateForm = ({
  values,
  dynamicVariables,
  loading,
  formRef,
  submitFailed,
  submitError,
  onCancel,
  handleSubmit,
  setContentEditorInstance,
}) => {
  return (
    <form
      onSubmit={handleSubmit}
      ref={formRef}
      className="customize-email-template"
    >
      <div className="m-b-24">
        <div className="flex" style={{ alignItems: 'center' }}>
          <label className="control-label m-b-0">Dynamic variables</label>
          <CustomTooltip
            placement="right"
            tooltip={
              <div style={{ maxWidth: '256px' }}>
                <strong>
                  <h5
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      lineHeight: '20px',
                      color: '#153142',
                    }}
                    className="m-b-8"
                  >
                    Add Variable
                  </h5>
                </strong>
                <p
                  style={{
                    fontSize: '12px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    color: '#7F8FA4',
                  }}
                  className="m-b-0 text-muted"
                >
                  A dynamic variable in emails refers to a placeholder that can
                  be replaced with specific information when sending the email.
                  Using dynamic variables in emails helps create a more engaging
                  and relevant experience for the email recipients. To add a
                  variable, click to the variable to copy its value and paste
                  where you need it.
                </p>
              </div>
            }
            id="tooltip"
          >
            <Button
              aria-label="View Support for Change modal"
              type="button"
              className="flex flex-align-center m-l-8 btn-last-update-icon"
            >
              <QuestionBlueIcon />
            </Button>
          </CustomTooltip>
        </div>

        <div className="flex flex-wrap m-t-8" style={{ gap: 8 }}>
          {dynamicVariables.map((variable, index) => (
            <CustomCopyElement variable={variable} index={index} />
          ))}
        </div>
      </div>
      <div style={{ padding: '32px 24px 2px 24px', background: '#F7FAFD' }}>
        <Field
          id="emailSubject"
          name="emailSubject"
          label="Email Subject"
          placeholder="Enter Email Subject"
          type="text"
          component={FieldGroup}
        />

        <Field name="customizeEmailBody">
          {({ name, input }) => {
            return (
              <Editor
                name={name}
                data={validateEditorData(input.value)}
                label="Email Body"
                setEditorInstanceForParent={setContentEditorInstance}
                options={{
                  holder: 'customize-email-template',
                }}
              />
            );
          }}
        </Field>

        <Field
          id="buttonText"
          name="buttonText"
          label="Button Text"
          placeholder="Enter Button Text"
          type="text"
          component={FieldGroup}
        />
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
      </div>
      <div
        className="flex"
        style={{ marginTop: '32px', justifyContent: 'space-between' }}
      >
        <div className="flex">
          <Button bsStyle="default" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            className="btn btn-outlined flex m-l-12"
            onClick={() => {
              values.finish = false;
              handleSubmit();
            }}
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Save'}
          </Button>
        </div>

        <Button
          className="m-l-12"
          bsStyle="primary"
          onClick={() => {
            values.finish = true;
            handleSubmit();
          }}
          disabled={loading}
        >
          {loading ? 'Sending...' : 'Send Feedback Form'}
        </Button>
      </div>
    </form>
  );
};
export default CustomizeEmailTemplateForm;
